import { useQuery } from '@abyss/web/hooks/useQuery';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import OptumRxGlobalSearch from './GetOptumRxGlobalSearch.gql';

export const useGetOptumRxGlobalSearch = (options) => {
  return useQuery(OptumRxGlobalSearch, {
    ...options,
    url: ApiUrl.graphQl(),
    headers: {
      'Accept-Encoding': 'gzip, deflate, br',
    },
  });
};
